import { Service, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DoorDataService } from '@data-services/doors';
import { FieldHeader } from '@models/companies';
import { DataContext } from '@services/data-context';
import { createPageResource } from '@utils';

@Service({ autoProvided: false })
export class FieldHeadersService {
  private readonly doorDataService = inject(DoorDataService);
  private readonly dataContext = inject(DataContext);
  private readonly translate = inject(TranslateService);

  readonly resource = createPageResource<FieldHeader[], { mbeProjectId: string | undefined }>({
    params: () => ({ mbeProjectId: this.dataContext.projectContext()?.mbeProjectId() }),
    loadAsync: ({ mbeProjectId }) => mbeProjectId
      ? this.doorDataService.getDoorFieldHeadersAsync(mbeProjectId)
      : this.doorDataService.getGenericDoorFieldHeadersAsync(),
    errorMessage: () => this.translate.instant('doorPages.loadHeadersError'),
    fallbackValue: []
  });
}
